var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',[_c('h1',[_vm._v(_vm._s(_vm.$t("pb-events")))]),_c('el-col',[_c('h2',[_c('a',{attrs:{"href":"https://www.plotbridge.io/activities/crosspb/","target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t("dp-xcc"))+" ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }